import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';
import SectionHead from '../ui/SectionHead';
import Spotlight from '../ui/Spotlight';
import { now } from '../../data/profile';
import './Now.css';

const STATUS = {
  live: { label: 'Live', cls: 'pill--accent' },
  building: { label: 'In progress', cls: 'pill--accent' },
  shipped: { label: 'Shipped', cls: 'pill--tan' },
  ongoing: { label: 'Ongoing', cls: '' },
};

export default function Now() {
  return (
    <section className="section now" id="now">
      <div className="container">
        <SectionHead
          index="01"
          label="Now"
          title={[{ text: 'What I’m' }, { text: 'involved in,', em: true }, { text: 'right now.' }]}
          aside={<p className="small">Updated {now.updated}. The things that currently take my days and some of my weekends.</p>}
        />

        <div className="now__grid">
          {now.items.map((item, i) => {
            const status = STATUS[item.status] || STATUS.ongoing;
            return (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 36 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.9, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              >
                <Spotlight className="card now__card">
                  <div className="now__top">
                    <span className="mono">{item.kind} &middot; {item.org}</span>
                    <span className={`pill ${status.cls}`}>
                      {(item.status === 'live' || item.status === 'building') && <span className="dot-live" />}
                      {status.label}
                    </span>
                  </div>
                  <h3 className="h3 now__title">{item.title}</h3>
                  <p className="body now__body">{item.body}</p>
                  <div className="now__foot">
                    <ul className="now__stack">
                      {item.stack.map((s) => (
                        <li key={s} className="pill">{s}</li>
                      ))}
                    </ul>
                    <div className="now__meta">
                      <span className="mono">Since {item.since}</span>
                      {item.href && item.href.startsWith('#') ? (
                        <a
                          href={item.href}
                          className="now__link"
                          onClick={(e) => {
                            e.preventDefault();
                            document.getElementById(item.href.slice(1))?.scrollIntoView({ behavior: 'smooth' });
                          }}
                        >
                          {item.ctaLabel || 'Open'} <FiArrowUpRight />
                        </a>
                      ) : item.href ? (
                        <a href={item.href} target="_blank" rel="noreferrer" className="now__link">
                          {item.ctaLabel || 'Open'} <FiArrowUpRight />
                        </a>
                      ) : null}
                    </div>
                  </div>
                </Spotlight>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
